import {
  createAction,
  createErrorAction,
  createPayloadAction,
} from '../../../core/helpers'

import {
  FETCH_DISHES,
  UPDATE_DISH_AI_SUGGESTIONS,
  UPDATE_DISH_DRAWER,
  UPDATE_DISH_INGREDIENTS_DRAWER_HOTKEYS,
  UPDATE_DISH_REMOVE_TIER_ONE_OVERRIDE_CONFIRMATION,
  UPDATE_DISH_TABLE_HOTKEYS,
} from '../action-types'

export const cleanupDishes = createAction(FETCH_DISHES.CLEANUP)

export const updateDishTableHotkeys = createPayloadAction(
  UPDATE_DISH_TABLE_HOTKEYS,
)

export const updateDishIngredientsDrawerHotkeys = createPayloadAction(
  UPDATE_DISH_INGREDIENTS_DRAWER_HOTKEYS,
)

export const updateDishRemoveTierOneConfirmationOverride = createPayloadAction(
  UPDATE_DISH_REMOVE_TIER_ONE_OVERRIDE_CONFIRMATION,
)

export const updateDishAiSuggestionsStart = createPayloadAction(
  UPDATE_DISH_AI_SUGGESTIONS.START,
)

export const updateDishAiSuggestionsFail = createErrorAction(
  UPDATE_DISH_AI_SUGGESTIONS.FAIL,
)

export const updateDishDrawer = createPayloadAction(UPDATE_DISH_DRAWER)
